import { useEffect } from 'react';
import { useDispatch, useReduxState } from 'hooks';

interface Params {
  blockId: number;
  dirty: boolean;
  disabled: boolean;
}

const useAnswerSubmissionTracker = ({ blockId, dirty, disabled }: Params) => {
  const { dispatch } = useDispatch();

  const {
    pageState: { taskBlockIdsWithUnsavedAnswers }
  } = useReduxState();

  const clearBlocKId = (blockId: number) => {
    const unsubmittedAnswers = { ...(taskBlockIdsWithUnsavedAnswers || {}) };
    delete unsubmittedAnswers[blockId];

    dispatch.updatePageState({
      taskBlockIdsWithUnsavedAnswers: unsubmittedAnswers
    });
  };

  const setBlockId = (blockId: number) => {
    const unsubmittedAnswers = { ...(taskBlockIdsWithUnsavedAnswers || {}) };
    unsubmittedAnswers[blockId] = true;

    dispatch.updatePageState({
      taskBlockIdsWithUnsavedAnswers: unsubmittedAnswers
    });
  };

  useEffect(() => {
    const unsubmittedAnswers = { ...(taskBlockIdsWithUnsavedAnswers || {}) };
    if (disabled) {
      if (unsubmittedAnswers[blockId]) clearBlocKId(blockId);
      return;
    }

    if (dirty && !unsubmittedAnswers[blockId]) setBlockId(blockId);
    else if (!dirty && unsubmittedAnswers[blockId]) clearBlocKId(blockId);
  }, [dirty]);

  return true;
};

export default useAnswerSubmissionTracker;
